// const showVideo = (video) => ((video.style.opacity = 1), video.paused && video.play().catch(() => {}))

// export default showVideo

const videoControls = () => {
  document.querySelectorAll('video').forEach((video) => {
    const btn = document.createElement('button')

    video.after(btn)

    btn.addEventListener('click', () => {
      video.muted = !video.muted

      if (video.muted) {
        video.setAttribute('muted', '')
      } else {
        video.removeAttribute('muted')
      }
    })
  })
}

export default videoControls
